import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #0f172a;
  padding: 4rem 0 3rem;
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #60a5fa;
  }
`;

export const Extra = styled("section")`
  background: #0f172a;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 0.25rem;
`;

export const Large = styled(Link)`
  font-size: 16px;
  color: #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-transform: capitalize;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  max-width: max-content;

  &:hover {
    color: #60a5fa;
  }
`;

export const Chat = styled("p")`
  color: #60a5fa;
  max-width: fit-content;
  cursor: pointer;
  margin-top: 0.5rem;
  font-size: 14px;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #93c5fd;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const Language = styled("h4")`
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #e2e8f0;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const Copyright = styled("p")`
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
`;

export const FooterGrid = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;

  @media only screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterColumn = styled("div")``;

export const SpotDealFooterBrand = styled("div")`
  margin-bottom: 1rem;

  span {
    color: #e2e8f0 !important;
  }

  img {
    box-shadow: none;
  }
`;

export const FooterLink = styled(Link)`
  display: block;
  color: #94a3b8;
  font-size: 14px;
  margin-bottom: 0.5rem;
  transition: color 0.2s ease;

  &:hover {
    color: #60a5fa;
  }
`;
